import { render, staticRenderFns } from "./Pls.vue?vue&type=template&id=ed834382&scoped=true"
import script from "./Pls.vue?vue&type=script&lang=js"
export * from "./Pls.vue?vue&type=script&lang=js"
import style0 from "./Pls.vue?vue&type=style&index=0&id=ed834382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed834382",
  null
  
)

export default component.exports